import React, { useEffect, useState } from 'react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      // Add hash to URL for footer contact animation
      if (id === 'footer-contact') {
        window.location.hash = 'footer-contact';
      }
    }
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'}`} data-id="element-210">
      <div className="max-w-7xl mx-auto px-6 py-4" data-id="element-211">
        <div className="flex items-center justify-between" data-id="element-212">
          <button onClick={() => scrollToSection('hero')} className="flex items-center gap-2 group" data-id="element-213">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uagsrCkks4pAM6FSLjUDBW/image.png" alt="GS HRC Logo" className="w-12 h-12 rounded-lg group-hover:scale-110 transition-transform" data-id="element-214" />
            <div className="flex flex-col items-start" data-id="element-215">
              <span className={`text-xl font-bold tracking-tight leading-none transition-colors ${isScrolled ? 'text-[#0B1220]' : 'text-white'}`} data-id="element-216">
                GS HRC
              </span>
              <span className={`text-xs leading-none transition-colors ${isScrolled ? 'text-gray-500' : 'text-gray-300'}`} data-id="element-217">
                Security Distribution
              </span>
            </div>
          </button>
          <div className="hidden md:flex items-center gap-8" data-id="element-218">
            <button onClick={() => scrollToSection('brands')} className={`text-sm font-medium transition-colors ${isScrolled ? 'text-[#0B1220] hover:text-[#3B82F6]' : 'text-white hover:text-gray-200'}`} data-id="element-219">
              Brands
            </button>
            <button onClick={() => scrollToSection('products')} className={`text-sm font-medium transition-colors ${isScrolled ? 'text-[#0B1220] hover:text-[#3B82F6]' : 'text-white hover:text-gray-200'}`} data-id="element-220">
              Products
            </button>
            <button onClick={() => scrollToSection('why-us')} className={`text-sm font-medium transition-colors ${isScrolled ? 'text-[#0B1220] hover:text-[#3B82F6]' : 'text-white hover:text-gray-200'}`} data-id="element-221">
              Why Us
            </button>
            <button onClick={() => scrollToSection('footer-contact')} className={`text-sm font-medium transition-colors ${isScrolled ? 'text-[#0B1220] hover:text-[#3B82F6]' : 'text-white hover:text-gray-200'}`} data-id="element-222">
              Contact
            </button>
            <button onClick={() => scrollToSection('contact')} className="px-5 py-2 bg-[#3B82F6] text-white rounded-lg text-sm font-medium hover:bg-[#2563EB] transition-colors" data-id="element-223">
              Get Line Sheet
            </button>
          </div>
        </div>
      </div>
    </nav>;
}